export enum CamerasSettingType {
  PIN = 'pin',
  IN_CAB_ALERTS = 'inCabAlerts',
  IN_CAB_ALERT_INATTENTIVE = 'inCabAlertInattentive',
  IN_CAB_ALERT_SEATBELT_UNBUCKLED = 'inCabAlertSeatbeltUnbuckled',
  IN_CAB_ALERT_PHONE_USE = 'inCabAlertPhoneUse',
  IN_CAB_ALERT_LENS_OBSTRUCTED = 'inCabAlertLensObstructed',
  IN_CAB_ALERT_SMOKING = 'inCabAlertSmoking',
  IN_CAB_ALERT_EATING_OR_DRINKING = 'inCabAlertEatingOrDrinking',
}

export type InCabAlertType =
  | CamerasSettingType.IN_CAB_ALERT_INATTENTIVE
  | CamerasSettingType.IN_CAB_ALERT_SEATBELT_UNBUCKLED
  | CamerasSettingType.IN_CAB_ALERT_PHONE_USE
  | CamerasSettingType.IN_CAB_ALERT_LENS_OBSTRUCTED
  | CamerasSettingType.IN_CAB_ALERT_SMOKING
  | CamerasSettingType.IN_CAB_ALERT_EATING_OR_DRINKING;

export const InCabAlertSettingType = new Set([
  CamerasSettingType.IN_CAB_ALERT_INATTENTIVE,
  CamerasSettingType.IN_CAB_ALERT_SEATBELT_UNBUCKLED,
  CamerasSettingType.IN_CAB_ALERT_PHONE_USE,
  CamerasSettingType.IN_CAB_ALERT_LENS_OBSTRUCTED,
  CamerasSettingType.IN_CAB_ALERT_SMOKING,
  CamerasSettingType.IN_CAB_ALERT_EATING_OR_DRINKING,
]);

export type InCabSettings = {
  minSpeedThresholdInMPH: number | null;
  value?: string;
  enabled?: boolean;
};

export interface CamerasSetting {
  name: CamerasSettingType;
  details: InCabSettings;
}

export type SafetyNotificationFormFields = {
  allowNotification: boolean | null;
  notificationFeed: boolean | null;
  groupNotifications: boolean | null;
  email: boolean | null;
  emailFrequency: EmailFrequency | null;
  subtypes: string[] | null;
};

export type ValidSafetyNotificationForm = SafetyNotificationFormFields;
export enum CamerasSettingsErrorCode {
  PIN_SAME_WITH_EXISTING_VALUE = 'PIN_SAME_WITH_EXISTING_VALUE',
  PIN_SAME_WITH_DEFAULT_VALUE = 'PIN_SAME_WITH_DEFAULT_VALUE',
}

export enum EmailFrequency {
  IMMEDIATELY = 'IMMEDIATE',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  BIWEEKLY = 'BI_WEEKLY',
}
